import {useEffect, useState, useRef } from 'react'
import { Tree } from 'primereact/tree'
import axios from 'axios'
import { Modal } from 'bootstrap'
import { ConfirmModalComponent } from '../Utils/ConfirmModal'
import { useToast } from '../../toastHook'
import { comparer } from '../../utils/comparer'

export const WordingComponent = props => {
    const { type } = props;
    const { display } = useToast();

    const [datasWithWording, setDatasWithWording] = useState();
    const [countInsertOrRemove, setCountInsertOrRemove] = useState(0);
    const [toInsertNom, setToInsertNom] = useState();
    const [toInsertWording, setToInsertWording] = useState();
    const modalSetInsert = useRef();
    const [toRemoveNom, setToRemoveNom] = useState();
    const [toRemoveWording, setToRemoveWording] = useState();
    const [openConfirmRemoveModal, setOpenConfirmRemoveModal] = useState(false);

    const showModalInsert = () => {
        const modal = Modal.getOrCreateInstance(modalSetInsert.current);
        modal.show();
    }

    const insertWording = () => {

        if (!toInsertWording) {
            return;
        }

        const modal = Modal.getOrCreateInstance(modalSetInsert.current);
        modal.hide();

        axios.post(`/api/${type}wording/add`, { nom : toInsertNom , wording: toInsertWording  })
            .then(response => {
                if (response && response.data && response.data.isSuccess) {

                    display({
                        titre: 'wording ajouté',
                        text: `le wording '${toInsertWording}' a été ajouté au nom ${toInsertNom}`,
                        severity: 'success'
                    })


                    setCountInsertOrRemove(countInsertOrRemove + 1)
                }
                else {
                    display({
                        titre: 'wording non ajouté',
                        text: `le wording '${toInsertWording}' n'a pas pu être ajouté au nom ${toInsertNom}, raison: ${response.data.reasonErrorMessage}`,
                        severity: 'danger'
                    })
                }
            });

        setToInsertNom('');
        setToInsertWording('');
    }

    const removeWording = () => {
        axios.post(`/api/${type}wording/remove`, { nom : toRemoveNom, wording: toRemoveWording }  )
            .then(response => {

                display({
                    titre: 'wording ajouté',
                    text: `le wording '${toRemoveWording}' a été ajouté au nom ${toRemoveNom}`,
                    severity: 'success'
                })

                setCountInsertOrRemove(countInsertOrRemove + 1)
            });

        setToRemoveNom('');
        setToRemoveWording('');
    }

    useEffect(() => {
        axios.get(`/api/${type}wording/get`)
            .then(response => {

                if (!response.data) {
                    return;
                }

                let datas = [];

                for (const key in response.data) {
                    const value = response.data[key];

                    let children = value.map(x => {
                        return {
                            key: `${key}-${x}`,
                            wording: x,
                            nom : key,
                            label: x
                        }
                    })

                    children.sort((x, y) => comparer(x.wording, y.wording));

                    datas.push({

                        key: key,
                        nom: key,
                        label: key,
                        children: children
                    });
                }

                datas.sort((x, y) => comparer(x.nom, y.nom));

                setDatasWithWording(datas);

            })
    }, [type, countInsertOrRemove]);

    const format = (node, options) => {
        if (!node.wording)
            return <div className="d-flex flex-row justify-content-between col-11" ><span>{node.nom}</span><i className="pi pi-plus text-success" onClick={() => { setToInsertNom(node.nom); showModalInsert(); } } ></i></div>
        else
            return <div className="d-flex flex-row justify-content-between col-11"><span>{node.wording}</span><i className="bi bi-x-circle text-danger" onClick={() => { setToRemoveNom(node.nom); setToRemoveWording(node.wording); setOpenConfirmRemoveModal(true); }} ></i></div>
    }

    return <div>
        <div ref={modalSetInsert} className="modal" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Ajouter un wording</h5>
                    </div>
                    <div className="modal-body">
                        <div className="alert alert-info">Vous allez ajouter un wording au terme <b>{toInsertNom}</b></div>
                       
                                <input className="form-control" type="text"  value={toInsertWording} onChange={ event => setToInsertWording(event.target.value) } />
                        </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-success" data-bs-dismiss="modal" onClick={insertWording} >OK</button>
                        <button className="btn btn-danger" data-bs-dismiss="modal">Annuler</button>
                    </div>
                </div>
            </div>
        </div>
        <ConfirmModalComponent open={openConfirmRemoveModal} setOpen={setOpenConfirmRemoveModal} titre="êtes vous sure de supprimer ?" message={`Vous allez supprimer le wording '${toRemoveWording}'' pour '${toRemoveNom}'' , êtes-vous sure ? `} onConfirm={() => removeWording()} />
        <Tree value={datasWithWording} filter  nodeTemplate={ format } className="w-full" /> </div>
}

export const ActiviteWordingComponent = () => <div><div className="alert alert-info">veuillez éditer ici le wording des activités</div><WordingComponent type="activite" /></div>
export const CompetenceWordingComponent = () => <div><div className="alert alert-info">veuillez éditer ici le wording des compétences</div><WordingComponent type="competence" /></div>
export const AdditionalDataWordingComponent = () => <div><div className="alert alert-info">veuillez éditer ici le wording des additional data</div><WordingComponent type="additionaldata" /></div>
















